import groupConverter from 'models/Group/converter'
import getCollectionByName from 'actions/base/getCollectionByName'

const getCollection = (withConverter = true) => getCollectionByName('groups', withConverter ? groupConverter : null)

export default getCollection
